import React, { useContext, useEffect, useState } from 'react'
import { AiFillCloseCircle } from 'react-icons/ai'
import { IoMdArrowDropdown } from 'react-icons/io'
import { IoChevronBackOutline } from 'react-icons/io5'
import { BiCheck } from 'react-icons/bi'

import Renderif from '../../components/renderif'
import DropDown, { DropDownOption } from '../../components/dropdown'
import BVCalendar from '../../components/calendar'
import { Service } from '../../services/api'
import { AuthContext } from '../../context/auth_context'

import ApiCalendar from "react-google-calendar-api";
import { AlertContext } from '../../context/alert_context'
import Loader from '../../components/loader'
const config = {
    clientId: "120251394725-odcgh221pgbild6n02k22a7qjsnls72i.apps.googleusercontent.com",
    apiKey: "AIzaSyDmACRaWHwMi8m8t3ivDh83o49N7XJS-aM",
    scope: "https://www.googleapis.com/auth/calendar",
    discoveryDocs: [
        "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
    ],
};
const apiCalendar = new ApiCalendar(config);

export default function AgendarCitaFamiliar({ ...props }) {

    let date = new Date();
    date.setDate(date.getDate() + 1)

    const { user } = useContext(AuthContext)
    const { notify } = useContext(AlertContext)
    const [state, setState] = useState({
        step: 0,
        selected_date: null,
        specialists: [],
        specialists_pisco: [],
        specialists_couch: [],
        selected_speciality: null,
        selected_specialist: null,
        selected_day: date,
        selected_time: '',
        selected_daytime: null,
        description: '',
        loading: false,
        family: [],
        selected_family: [],
        selected_family_id: [],
        hours: [],
        available: null,
        busy: []

    })
    useEffect(() => {


        const run = async () => {
            const psico = await Service('GET', 'Appointment/specialist/1')
            const couch = await Service('GET', 'Appointment/specialist/2')
            const family = await Service('GET', 'Family');
            console.log(family)

            // setState({ ...state, family: family.data, specialists_pisco: psico.data, specialists_couch: couch.data, specialists: [...psico.data, ...couch.data] })
            setState({ ...state, family: family.data, specialists_pisco: psico.data, specialists_couch: couch.data.filter((couch) => couch.id !=="39951cfb-db8e-458a-bd45-1e008e1a92bd" && couch.id !=="4346535a-79ea-4756-994e-d14d937093df" && couch.id !=="aa534137-f287-48b2-866a-f2816973f335"), specialists: [ ...couch.data.filter((couch) => couch.id !=="39951cfb-db8e-458a-bd45-1e008e1a92bd" && couch.id !=="4346535a-79ea-4756-994e-d14d937093df" && couch.id !=="aa534137-f287-48b2-866a-f2816973f335")] })

        }
        run()

        return () => { }

    }, [])

    Number.prototype.pad = function (size) {
        var s = String(this);
        while (s.length < (size || 2)) { s = "0" + s; }
        return s;
    }

    const _schedule = async () => {


        setState({ ...state, loading: true })


        try {
            const start = new Date(state.selected_daytime);
            const end = new Date(state.selected_daytime.setHours(state.selected_daytime.getHours() + 1));
            // const res = await apiCalendar.handleAuthClick();

            var day = start.getDate();
            var month = start.getMonth() + 1; //months are zero based
            var year = start.getFullYear();
            const time = start.toLocaleTimeString('es-ES').replace(/(.*)\D\d+/, '$1');
            let date_parsed = year + '-' + month.pad() + '-' + day.pad() + 'T' + (time.length<5?"0"+time:time) + ':00.000Z';


            let familyMembers = [];
            state.selected_family.map((item) => {
                familyMembers.push(item.id)
            })
            let body = {
                userId: user.id,
                specialistId: state.selected_specialist.id,
                date: date_parsed,
                description: "Cita Bien Vivir",
                familyMembers
            }

            const schedule = await Service('POST', 'Appointment/family', body);

            if (schedule?.status === 200) {
                notify({ title: 'Listo!', message: 'Se ha agendado un nueva cita.', type: 'success' })

                let callback = {
                    date: date_parsed,
                    numberOfSession: 0,
                    specialist: state.selected_specialist,
                    familyMembers
                }
                props.onSchedule(callback)

                props.onCancel()
            } else {
                notify({ title: 'Error!', message: 'No se puede agendar una cita en este momento.', type: 'error' })
                props.onCancel()
            }


            // if (res.access_token !== undefined) {
            //     const eventWithVideoConference = {
            //         summary: "Cita Bien Vivir",
            //         start: {
            //             dateTime: start,
            //             timeZone: "America/Mexico_City",
            //         },
            //         end: {
            //             dateTime: end,
            //             timeZone: "America/Mexico_City",
            //         },
            //     };

            //     apiCalendar
            //         .createEventWithVideoConference(eventWithVideoConference)
            //         .then(async (result) => {
            //             console.log(result);

            //             let familyMembers = [];
            //             state.selected_family.map((item) => {
            //                 familyMembers.push(item.id)
            //             })

            //             let body = {
            //                 userId: user.id,
            //                 specialistId: state.selected_specialist.id,
            //                 date: start,
            //                 description: "Cita Bien Vivir",
            //                 sessionUrl: result.result.hangoutLink,
            //                 familyMembers
            //             }
            //             console.log(body);
            //             const schedule = await Service('POST', 'Appointment', body);

            //             if (schedule?.status === 200) {
            //                 notify({ title: 'Listo!', message: 'Se ha agendado un nueva cita.', type: 'success' })

            //                 let callback = {
            //                     date: start,
            //                     sessionUrl: result.result.hangoutLink,
            //                     numberOfSession: 0,
            //                     specialist: state.selected_specialist,
            //                     familyMembers
            //                 }
            //                 props.onSchedule(callback)

            //                 props.onCancel()
            //             } else {
            //                 notify({ title: 'Error!', message: 'No se puede agendar una cita en este momento.', type: 'error' })
            //                 props.onCancel()
            //             }




            //             console.log(schedule)
            //         })
            //         .catch((error) => {
            //             console.log(error);
            //             notify({ title: 'Error!', message: 'Al conectar con Google Calendar.', type: 'error' })
            //             props.onCancel()
            //         });
            // }

        } catch (error) {
            console.log(error)
            notify({ title: 'Error!', message: 'Al conectar con Google Calendar.', type: 'error' })
        }


    }


    var arr = [
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
    ]

    var weekday = new Array(7);
    weekday[0] = "Domingo";
    weekday[1] = "Lunes";
    weekday[2] = "Martes";
    weekday[3] = "Miercoles";
    weekday[4] = "Jueves";
    weekday[5] = "Viernes";
    weekday[6] = "Sabado";

    var weekday_en = new Array(7);
    weekday_en[0] = "Sunday";
    weekday_en[1] = "Monday";
    weekday_en[2] = "Tuestday";
    weekday_en[3] = "Wednesday";
    weekday_en[4] = "Thursday";
    weekday_en[5] = "Friday";
    weekday_en[6] = "Saturday";

    var months = new Array(7);
    months[0] = "Enero";
    months[1] = "Febrero";
    months[2] = "Marzo";
    months[3] = "Abril";
    months[4] = "Mayo";
    months[5] = "Junio";
    months[6] = "Julio";
    months[7] = "Agosto";
    months[8] = "Septiembre";
    months[9] = "Octubre";
    months[10] = "Noviembre";
    months[11] = "Diciembre";


    return (
        <>
            <Renderif isTrue={state.loading === true}>
                <Loader></Loader>
            </Renderif>
            <div className='overlay d-flex justify-content-center align-items-center'>
                <Renderif isTrue={state.step === 0}>
                    <div className='bv-modal shadow'>

                        <div className='px-4 pt-3 pb-4 d-flex align-items-center'>
                            <div className='f-16 text-gray bold'>Agendar Cita Familiar</div>
                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                        </div>

                        <div className='px-4 pb-5'>


                            <div className='mt-2'>
                                <DropDown
                                    title='Seleccione la Especialidad deseada (Opcional)'
                                    open={false}
                                    defaultValue={0}
                                    _onChange={(evt) => {
                                        switch (evt.value) {
                                            case 1:
                                                setState({ ...state, selected_speciality: evt, specialists: state.specialists_pisco })
                                                break;
                                            case 2:
                                                setState({ ...state, selected_speciality: evt, specialists: state.specialists_couch })
                                                break;

                                            default:
                                                setState({ ...state, selected_speciality: evt, specialists: [...state.specialists_couch] })
                                                break;
                                        }

                                    }}>
                                    <DropDownOption value={0} label="Todas Las Especialidades">
                                        <div className='f-14 text-gray'>Todas Las Especialidades</div>
                                    </DropDownOption>
                                    {/* <DropDownOption value={1} label="Psicologia">
                                        <div className='f-14 text-gray'>Psicologia</div>
                                    </DropDownOption> */}
                                    <DropDownOption value={2} label="Coach">
                                        <div className='f-14 text-gray'>Coach</div>
                                    </DropDownOption>




                                </DropDown>
                            </div>

                            <div className='mt-2'>
                                <DropDown
                                    title='Seleccione el Profesional'
                                    open={false}
                                    // defaultValue={0} 
                                    _onChange={(evt) => {
                                        console.log(evt)
                                        setState({ ...state, selected_specialist: evt.value })
                                    }}>

                                    {
                                        state.specialists.map((item, i) => {
                                            return (
                                                <DropDownOption key={i} value={item} label={`${item.firstName} ${item.lastName}`}>
                                                    <div className='f-14 text-gray'>{item.firstName} {item.lastName}</div>
                                                </DropDownOption>
                                            )
                                        })
                                    }




                                </DropDown>
                            </div>








                        </div>

                        <div className='d-flex b-top p-4'>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}>Cancelar</div>
                            <div className='bv-pill bv-pill--primary cursor-pointer' onClick={async () => {

                                if (state.selected_specialist !== null) {


                                    let _available = await Service('GET', `Appointment/dates-labor/${state.selected_specialist.id}`)
                                    console.log(_available)
                                    let _busy = await Service('GET', `Appointment/dates-busy/${state.selected_specialist.id}`)
                                    console.log(_busy)

                                    setState({ ...state, step: state.step + 1, available: _available.data, busy: _busy.data })
                                }

                            }}>Continuar</div>
                        </div>

                    </div>
                </Renderif>
                <Renderif isTrue={state.step === 1}>
                    <div className='bv-modal shadow'>

                        <div className='px-4 pt-3 pb-4 d-flex align-items-center'>

                            <div className='f-16 text-gray bold'>Agendar Cita Familiar</div>
                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                        </div>

                        <div className='text-gray f-12 px-4 py-1'>
                            Selecciona que miembros de tu familia asistiran a la sesión.
                        </div>

                        <div className='d-flex p-4'>
                            {state.family.map((item, i) => {
                                return (
                                    <div className='d-flex flex-column  align-items-center'>
                                        <div className={`avatar avatar--xl cursor-pointer mx-2 ${state.selected_family.some((member) => member.id === item.id) === true ? 'avatar--active' : ''}`} style={{ 'backgroundImage': 'url(' + item.photo + ')' }} onClick={() => {

                                            if (state.selected_family.some((member) => member.id === item.id)) {

                                                state.selected_family = state.selected_family.filter((member) => member.id !== item.id);
                                            } else {
                                                state.selected_family.push(item);
                                            }


                                            setState({ ...state })

                                        }}></div>
                                        <div className='text-gray f-12 text-center no-wrap px-1'>{item.firstName}</div>
                                    </div>
                                )

                            })}
                        </div>

                        <div className='d-flex b-top p-4'>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                setState({ ...state, step: state.step - 1 })
                            }}> <IoChevronBackOutline size={24} color="#30B7E7"></IoChevronBackOutline></div>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}>Cancelar</div>
                            <div className='bv-pill bv-pill--primary cursor-pointer' onClick={() => {
                                setState({ ...state, step: state.step + 1 })
                            }}>Continuar</div>
                        </div>
                    </div>
                </Renderif>
                <Renderif isTrue={state.step === 2}>
                    <div className='bv-modal shadow'>

                        <div className='px-4 pt-3 pb-4 d-flex align-items-center'>

                            <div className='f-16 text-gray bold'>Agendar Cita Familiar</div>
                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                        </div>

                        <div className='text-gray f-12 px-4 py-1'>
                            Descripcion y detalles de la cita.
                        </div>

                        <div className='px-4 pb-5'>
                            <textarea rows="4" className='input--light py-1' value={state.description} onChange={(evt) => {
                                setState({ ...state, description: evt.currentTarget.value })
                            }}></textarea>
                        </div>
                        <div className='d-flex b-top p-4'>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                setState({ ...state, step: state.step - 1 })
                            }}> <IoChevronBackOutline size={24} color="#30B7E7"></IoChevronBackOutline></div>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}>Cancelar</div>
                            <div className='bv-pill bv-pill--primary cursor-pointer' onClick={() => {
                                setState({ ...state, step: state.step + 1 })
                            }}>Continuar</div>
                        </div>
                    </div>
                </Renderif>
                <Renderif isTrue={state.step === 3}>
                    <div className='bv-modal shadow'>

                        <div className='px-4 pt-3 pb-4 d-flex align-items-center'>

                            <div className='f-16 text-gray bold'>Agendar Cita Familiar</div>
                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                        </div>

                        <div className='text-gray f-12 px-4'>
                            Seleccione entre los dias disponibles del Medico Seleccionado para ver su agenda y escoger el horario de consulta que mas le convenga.
                        </div>


                        {/* BODY */}
                        <div className='d-flex overflow-hidden py-2 px-4'>

                            <div className='col'>
                                <BVCalendar init={date} onChange={(evt) => {
                                    let y = evt.getFullYear()
                                    let m = (evt.getMonth() + 1) < 10 ? '0' + (evt.getMonth() + 1) : (evt.getMonth() + 1)
                                    let d = evt.getDate() < 10 ? '0' + evt.getDate() : evt.getDate()

                                    console.log(y + "-" + m + "-" + d)

                                    let _busy = []
                                    state.busy.map((busy_date) => {
                                        console.log(busy_date.split('T')[0])
                                        if (busy_date.split('T')[0] === y + "-" + m + "-" + d) {
                                            console.log("CITAS EN ESE DIA, VALIDAR HORARIO")
                                            _busy.push(busy_date.split('T')[1])
                                        }
                                    })


                                    let day = weekday_en[evt.getDay()]
                                    let horarios = state.available?.filter((item) => item.dayOfWeek === day)[0]?.timeRanges

                                    let hours = []

                                    horarios?.map((horario) => {
                                        console.log(horario)
                                        let start = horario.startTime;
                                        let end = horario.endTime;


                                        let time_start = new Date();
                                        time_start.setHours(start.split(':')[0], start.split(':')[1], start.split(':')[2])

                                        let time_end = new Date();
                                        time_end.setHours(end.split(':')[0], end.split(':')[1], end.split(':')[2])



                                        let hora = new Date();
                                        for (let i = time_start.getHours(); i <= time_end.getHours() - 1; i++) {

                                            hora.setHours(i, start.split(':')[1], '00')
                                            let h = hora.getHours() >= 10 ? hora.getHours() : '0' + hora.getHours()
                                            let m = hora.getMinutes() >= 10 ? hora.getMinutes() : '0' + hora.getMinutes()
                                            let hm = h + ':' + m;
                                            console.log(hm)
                                            console.log(_busy)
                                            if (!_busy.includes(hm + ":00")) {
                                                hours.push(hm)
                                            }


                                        }



                                    })
                                    // console.log(evt)
                                    // if(evt < new Date()){
                                    //     console.log("NEL")
                                    //     return;
                                    // }
                                    setState({ ...state, selected_day: evt, hours })
                                }}></BVCalendar>
                            </div>

                            <div className='col overflow-auto hide-scroll ps-3 d-none'>



                                {
                                    arr.map((item, i) => {
                                        return (
                                            <div key={i} className={`d-flex align-items-center py-2 b-bottom ps-1 ${state.selected_time === i ? 'highlight-active' : ''}`}>
                                                <div className='col f-12 text-gray'>{weekday[new Date(state.selected_day).getDay()]} {new Date(state.selected_day).getDate()}</div>
                                                <div className='col f-12 text-gray'>{months[new Date(state.selected_day).getMonth()]} {new Date(state.selected_day).getFullYear()}</div>
                                                <div className='col f-12 text-gray'>{item}</div>
                                                <div className={`bv-pill cursor-pointer ${state.selected_time === i ? 'bv-pill--primary' : 'bv-pill--gray'}`} onClick={() => {



                                                    let daytime = new Date(new Date(state.selected_day).setHours(item.split(':')[0], item.split(':')[1], '00'));
                                                    console.log(daytime)

                                                    setState({ ...state, selected_time: i, selected_daytime: daytime })
                                                }}>Seleccionar</div>
                                            </div>
                                        )
                                    })
                                }


                            </div>
                            <div className='col overflow-auto hide-scroll ps-3'>

                                <Renderif isTrue={state.selected_day < new Date()}>
                                    <div className='f-14 bold text-gray'>En BienVivir, programar citas solo es posible a partir del día siguiente.</div>
                                </Renderif>


                                <Renderif isTrue={state.selected_day > new Date()}>
                                    {
                                        state.hours.map((item, i) => {
                                            // console.log(state.selected_day)
                                            return (
                                                <div key={i} className={`d-flex align-items-center justify-content-center py-2 b-bottom ps-1 highlight-hover ${state.selected_time === i ? 'highlight-active' : ''}`} onClick={() => {
                                                    let daytime = new Date(new Date(state.selected_day).setHours(item.split(':')[0], item.split(':')[1], '00'));
                                                    console.log(daytime.getDate())




                                                    setState({ ...state, selected_time: i, selected_daytime: daytime })
                                                }}>
                                                    <div className='col f-12 text-gray'>{weekday[new Date(state.selected_day).getDay()]} {new Date(state.selected_day).getDate()}</div>
                                                    <div className='col f-12 text-gray'>{months[new Date(state.selected_day).getMonth()]} {new Date(state.selected_day).getFullYear()}</div>
                                                    <div className='col f-12 text-gray'>{item}</div>
                                                    <div className='bv-icon bv-icon--mid me-2'>
                                                        <BiCheck size={28} color={`${state.selected_time === i ? '#0972CE' : 'transparent'}`}></BiCheck>
                                                    </div>
                                                    {/* <div className={`bv-pill cursor-pointer ${i === 0 ? 'bv-pill--primary':'bv-pill--gray'}`}>Seleccionar</div> */}
                                                </div>
                                            )
                                        })
                                    }
                                </Renderif>


                            </div>
                        </div>
                        {/* EDN BODY */}


                        <div className='d-flex b-top p-4'>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                setState({ ...state, step: state.step - 1 })
                            }}> <IoChevronBackOutline size={24} color="#30B7E7"></IoChevronBackOutline></div>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}>Cancelar</div>
                            <div className='bv-pill bv-pill--primary cursor-pointer' onClick={() => {
                                if (state.selected_daytime !== null) {
                                    setState({ ...state, step: state.step + 1 })
                                }

                            }}>Continuar</div>
                        </div>


                    </div>
                </Renderif>
                <Renderif isTrue={state.step === 4}>
                    <div className='bv-modal shadow'>

                        <div className='px-4 pt-3 pb-4 d-flex align-items-center'>
                            <div className='f-16 text-gray bold'>Confirmar Cita</div>
                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                        </div>

                        <div className='px-4 pb-5'>

                            <div className='f-14 text-gray'>Su cita sera programada de la siguiente manera.</div>

                            <div className='d-flex py-4'>
                                {state.selected_family.map((item, i) => {
                                    return (
                                        <div className='d-flex flex-column  align-items-center'>
                                            <div className={`avatar avatar--big avatar--active mx-2`} style={{ 'backgroundImage': 'url(' + item.photo + ')' }}></div>
                                            <div className='text-gray f-12 text-center no-wrap px-1'>{item.firstName}</div>
                                        </div>
                                    )

                                })}
                            </div>



                            <div className='f-14 text-black bold'>
                                {weekday[new Date(state.selected_day).getDay()]} {new Date(state.selected_day).getDate()} {months[new Date(state.selected_day).getMonth()]} {new Date(state.selected_day).getFullYear()}

                            </div>
                            <div className='f-14 text-gray'>Con <span className='text-black bold'>{state.selected_specialist?.firstName} {state.selected_specialist?.lastName} </span> en la Especialidad de: <span className='text-black bold'>{state?.selected_speciality?.label}</span>  </div>






                        </div>

                        <div className='d-flex b-top p-4'>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                setState({ ...state, step: state.step - 1 })
                            }}> <IoChevronBackOutline size={24} color="#30B7E7"></IoChevronBackOutline></div>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}>Cancelar</div>

                            <div className='bv-pill bv-pill--primary cursor-pointer' onClick={() => {
                                _schedule()

                            }}>Confirmar</div>
                        </div>

                    </div>
                </Renderif>
            </div>
        </>
    )
}
